import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative top-20 min-h-[calc(100vh-5rem)] p-2 sm:p-4 max-w-6xl m-auto" }
const _hoisted_2 = { class: "cursor-pointer hover:bg-gray-500 rounded-md px-1 font-normal" }

import AlertComponent from '@/components/shared/AlertComponent.vue';
import NavigationBar from '@/layout/NavigationBar.vue';
import { ref, watch, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { capitalize } from './util/universal';
import { loadConfig } from '@/composables/firebase';
import { config } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onBeforeMount(async () => {
	// reload remote config from firebase
	if (config.useRemoteConfig && config.env !== 'local' && !validateStorage()) {
		const expired = new Date(new Date().getTime() + 15 * 60 * 1000); // add 15 minute from now
		localStorage.setItem('remote-config-expired', expired.toISOString());

		const host = await loadConfig('hostUnikumeKinkando');
		const oldHost = localStorage.getItem('host');
		localStorage.setItem('host', host);

		if (oldHost !== host) {
			window.location.reload();
		}
	}
});

const route = useRoute();
const paths = ref(route.path.split('/'));
watch(route, () => {
	if (route.matched?.length === 1) {
		paths.value = route.matched[0].path
			.split('/')
			.filter((path) => {
				let hidePaths: string[] = [];
				if (route.meta.hideBreadcrumbPath) {
					hidePaths = route.meta.hideBreadcrumbPath as string[];
				}
				return !hidePaths.includes(path);
			})
			.map((path) => {
				const pathValue = route.params[path.startsWith(':') ? path.substring(1) : path] as
					| string
					| undefined;
				return pathValue || path;
			});
	} else {
		paths.value = route.path.split('/');
	}
});

function validateStorage(): boolean {
	const host = localStorage.getItem('host');
	if (!host) {
		return false;
	}
	const remoteConfigExpired = localStorage.getItem('remote-config-expired');
	if (!remoteConfigExpired) {
		return false;
	}
	try {
		const expired = new Date(remoteConfigExpired).getTime();
		const now = new Date().getTime();
		return now < expired;
	} catch (error) {
		return false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AlertComponent),
    _createVNode(NavigationBar),
    _createElementVNode("div", _hoisted_1, [
      (_unref(route).path !== '/' && _unref(route).name)
        ? (_openBlock(), _createBlock(_component_a_breadcrumb, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paths.value, (path, index) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: paths.value.slice(0, index + 1).join('/') || '/'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(!path ? 'Home' : _unref(capitalize)(path, '-')), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})